// extracted by mini-css-extract-plugin
module.exports = {"searchPageContainer":"Filters-module__searchPageContainer","NewContainer":"Filters-module__NewContainer"};